import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Teleport as _Teleport, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f1903b58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card_text_and_image_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/guider/tagluffning-for-nyborjare" }, " Tågluffning för nybörjare", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/guider/med-pa-resan" }, " Vad får jag med på resan?", -1))

import TextBlock from "../../blocks/TextBlock.vue";
import ContentWrapper from "../../generics/ContentWrapper.vue";
import PageTitle from "../../blocks/PageTitle.vue";
import CustomPic from "../../generics/CustomPic.vue";
import meta from "@/data/meta.json";
import GridCard from "../GridCard.vue";
import ListCard from "../ListCard.vue";
import { useRoute } from "vue-router";
import { computed } from "vue";
import Breadcrumbs from "@/components/generics/BreadCrumbs.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DestinationGuide',
  setup(__props) {

const route = useRoute();

const basePath = computed(() => route.path.replace(/\/$/, ""));

const items = computed(() => [
	{
		title: "Belgien",
		image: "🇧🇪",
		description:
			"Mäktiga slott, belgisk choklad och öl i världsklass i hjärtat av Europa.",
		link: `${basePath.value}/belgien`,
	},
	{
		title: "Bosnien-Hercegovina",
		image: "🇧🇦",
		description:
			"Upptäck oslagbar natur, orientaliska influenser och historiska städer.",
		link: `${basePath.value}/bosnien-hercegovina`,
	},
	{
		title: "Bulgarien",
		image: "🇧🇬",
		description:
			"Från Svarta havets stränder till antika ruiner och bergsbyar.",
		link: `${basePath.value}/bulgarien`,
	},
	{
		title: "Danmark",
		image: "🇩🇰",
		description: "Kustnära charm, hygge och cykelvänliga storstäder.",
		link: `${basePath.value}/danmark`,
	},
	{
		title: "Estland",
		image: "🇪🇪",
		description: "Digitalt land med medeltida städer och tyst vildmark.",
		link: `${basePath.value}/estland`,
	},
	{
		title: "Finland",
		image: "🇫🇮",
		description: "Tusen sjöars land med bastu, skogar och norrsken.",
		link: `${basePath.value}/finland`,
	},
	{
		title: "Frankrike",
		image: "🇫🇷",
		description: "Renässansens vagga - perfekt för konst, vin och landsbygd.",
		link: `${basePath.value}/frankrike`,
	},
	{
		title: "Grekland",
		image: "🇬🇷",
		description: "Egeiska öar, antika tempel och det grekiska kökets pärlor.",
		link: `${basePath.value}/grekland`,
	},
	{
		title: "Irland",
		image: "🇮🇪",
		description: "Gröna fält, pubkultur och dramatiska klippkuster.",
		link: `${basePath.value}/irland`,
	},
	{
		title: "Italien",
		image: "🇮🇹",
		description:
			"Kultur, pasta, kustbyar och renässans – la dolce vita väntar.",
		link: `${basePath.value}/italien`,
	},
	{
		title: "Kroatien",
		image: "🇭🇷",
		description:
			"Adriatiska havets pärla med gamla städer och kristallklart vatten.",
		link: `${basePath.value}/kroatien`,
	},
	{
		title: "Lettland",
		image: "🇱🇻",
		description: "Oupptäckt pärla med kuststäder, skogar och Baltisk charm.",
		link: `${basePath.value}/lettland`,
	},
	{
		title: "Litauen",
		image: "🇱🇹",
		description: "Medeltida städer, sanddyner och vacker natur i öst.",
		link: `${basePath.value}/litauen`,
	},
	{
		title: "Luxemburg",
		image: "🇱🇺",
		description: "Litet land med stora upplevelser – slott, skogar och lyx.",
		link: `${basePath.value}/luxemburg`,
	},
	{
		title: "Makedonien",
		image: "🇲🇰",
		description: "Balkansk mystik med sjöar, kyrkor och bergskedjor.",
		link: `${basePath.value}/makedonien`,
	},
	{
		title: "Montenegro",
		image: "🇲🇪",
		description: "Liten kustnation med storslagen natur och gamla städer.",
		link: `${basePath.value}/montenegro`,
	},
	{
		title: "Nederländerna",
		image: "🇳🇱",
		description: "Cykelvänliga städer, tulpanfält och charmiga kanaler.",
		link: `${basePath.value}/nederlanderna`,
	},
	{
		title: "Norge",
		image: "🇳🇴",
		description: "Fjordar, tåg genom bergen och storslagen vildmark.",
		link: `${basePath.value}/norge`,
	},
	{
		title: "Polen",
		image: "🇵🇱",
		description: "Historiska städer, vacker kust och tät skog.",
		link: `${basePath.value}/polen`,
	},
	{
		title: "Portugal",
		image: "🇵🇹",
		description: "Surf, stadsliv och färgglada gränder med fado.",
		link: `${basePath.value}/portugal`,
	},
	{
		title: "Rumänien",
		image: "🇷🇴",
		description: "Drakulalegender, karpatiska berg och färgstarka byar.",
		link: `${basePath.value}/rumänien`,
	},
	{
		title: "Schweiz",
		image: "🇨🇭",
		description: "Tåg genom alperna, choklad och vykortsvyer.",
		link: `${basePath.value}/schweiz`,
	},
	{
		title: "Serbien",
		image: "🇷🇸",
		description: "Levande nattliv, historia och flodnära storstäder.",
		link: `${basePath.value}/serbien`,
	},
	{
		title: "Slovakien",
		image: "🇸🇰",
		description: "Underskattad pärla med grottor, slott och naturreservat.",
		link: `${basePath.value}/slovakien`,
	},
	{
		title: "Slovenien",
		image: "🇸🇮",
		description: "Grönskande landskap, sjöar och grottor i Alpernas famn.",
		link: `${basePath.value}/slovenien`,
	},
	{
		title: "Spanien",
		image: "🇪🇸",
		description: "Stränder, tapas, berg och ett rikt kulturarv.",
		link: `${basePath.value}/spanien`,
	},
	{
		title: "Storbritannien",
		image: "🇬🇧",
		description: "Pubkultur, tågresor i högland och drottninglig charm.",
		link: `${basePath.value}/storbritannien`,
	},
	{
		title: "Tjeckien",
		image: "🇨🇿",
		description: "Sagostäder, billig öl och klassisk arkitektur.",
		link: `${basePath.value}/tjeckien`,
	},
	{
		title: "Turkiet",
		image: "🇹🇷",
		description: "Mellan öst och väst – marknader, moskéer och medelhavskust.",
		link: `${basePath.value}/turkiet`,
	},
	{
		title: "Tyskland",
		image: "🇩🇪",
		description: "Historiska städer, öltradition och effektiv tågtrafik.",
		link: `${basePath.value}/tyskland`,
	},
	{
		title: "Ungern",
		image: "🇭🇺",
		description: "Termalbad, pampiga broar och Donauutsikt i Budapest.",
		link: `${basePath.value}/ungern`,
	},
	{
		title: "Österrike",
		image: "🇦🇹",
		description: "Klassisk musik, alper och eleganta stadspromenader.",
		link: `${basePath.value}/osterrike`,
	},
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent('script'), { type: "application/ld+json" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(meta).destinationsGuide), 1)
        ]),
        _: 1
      }))
    ])),
    _createVNode(PageTitle, {
      text: "Destinationer i Europa",
      textColor: "black",
      borderColor: "black",
      maxHeight: "60vh",
      backgroundImageClass: "background-countries"
    }),
    _createVNode(ContentWrapper, { showBreadcrumbs: true }, {
      default: _withCtx(() => [
        _createVNode(Breadcrumbs),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(TextBlock, { header: "Destinationer ditt interrailkort når" }, {
            default: _withCtx(() => [
              _createTextVNode(" Ditt interrailkort tar dig till 33 av Europas länder. Vi har tagit fram guider för många av dessa länder för att ge dig inspiration inför din tågluff. De flesta stora städer i Europa går lätt att ta sig till med tåg, men du kan också uppleva stränder, hav, vildmark, natur och mycket mer längre från civilisationen. Vi har alltid tillgängligheten med i tanken när våra guider utformats. ")
            ]),
            _: 1
          }),
          _createVNode(TextBlock, { header: "Att resa med tåg i Europa" }, {
            default: _withCtx(() => [
              _createTextVNode(" Matnyttig information om hur du bäst reser med tåg i Europa finner du i vår guide "),
              _hoisted_2,
              _createTextVNode(". Alla landsspecifika råd finns att funna under varje lands guide. Huruvida du kan resa med mer än bara väska, till exempel rullstol eller cykel, kan du läsa om i "),
              _hoisted_3,
              _createTextVNode(". ")
            ]),
            _: 1
          }),
          _createVNode(GridCard, {
            title: "Destinationer i Europa",
            items: _unref(items)
          }, null, 8, ["items"])
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})